import { render, staticRenderFns } from "./Dice.vue?vue&type=template&id=8ec5c092&scoped=true"
import script from "./Dice.vue?vue&type=script&lang=js"
export * from "./Dice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec5c092",
  null
  
)

export default component.exports